import { Injectable, signal } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class DevService {
	readonly codeEditorShowHiddenAreas = signal(false)
}
